export const ADD_CUSTOMER_APIS = {
  offline_instalment_type_payment: "payments/exly/offline/payment/installments",
};
